import FormularioService from '@/services/FormularioService';

export const namespaced = true;

export const state = {
  historico: null,
};

export const mutations = {
  SET_HISTORICO(state, historico) {
    state.historico = historico;
  },
};

export const actions = {
  getHistorico({commit}, idFormulario) {
    commit("SET_HISTORICO", null);
    FormularioService.getHistoricoEstados(idFormulario)
      .then(r => r.json())
      .then(historico => {
        commit("SET_HISTORICO", historico);
        return historico;
      });
  },
};

export const getters = {};
